import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { JSX, useEffect, useState } from "react";
export const AnimatedButton = t0 => {
  const $ = _c(7);
  const {
    onClick,
    className,
    text,
    icon
  } = t0;
  const [isVisible, setIsVisible] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleScroll = function handleScroll() {
        setIsVisible(window.scrollY > 0);
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = `shadow-4 !fixed z-[12] !flex w-[222px] whitespace-nowrap !bg-white !px-0 transition-transform duration-300 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"} ${className}`;
  let t4;
  if ($[2] !== icon || $[3] !== onClick || $[4] !== t3 || $[5] !== text) {
    t4 = <Button StartIcon={icon} className={t3} color="secondary" onClick={onClick} size="large" text={text} variant="round-outline" />;
    $[2] = icon;
    $[3] = onClick;
    $[4] = t3;
    $[5] = text;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};